import React from 'react';
import { GiftIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const CHECKOUT_URL = 'https://musicapronta.impultienda.ar/checkout';
const lines = [{
  label: '10 Volumi Completi',
  value: '97 €'
}, {
  label: '5 Bonus Esclusivi',
  value: '128 €'
}];
export function Offer() {
  return <section id="offer" className="w-full scroll-mt-16 bg-cream px-5 py-16 sm:py-24" data-id="element-133" data-mp="1ho5ye6m8v41b">
      <div className="mx-auto max-w-xl" data-id="element-134" data-mp="tybnhulhjpjp">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.22em] text-orange sm:text-xs" data-id="element-135" data-mp="tzd7iokhbmdk">
          Offerta di lancio
        </p>
        <h2 className="mt-4 flex items-center justify-center gap-3 text-center text-[26px] font-extrabold tracking-tight text-navy sm:text-4xl" data-id="element-136" data-mp="13xkd6b9bii09">
          <GiftIcon className="h-6 w-6 flex-none text-orange sm:h-7 sm:w-7" aria-hidden="true" data-id="element-137" data-mp="ywd7qiunduwr" />
          Offerta Speciale di Lancio
        </h2>

        <div className="relative mt-12 rounded-4xl border border-navy/10 bg-white px-6 pb-8 pt-10 shadow-[0_24px_70px_-45px_rgba(28,58,107,0.6)] sm:px-10 sm:pb-10 sm:pt-12" data-id="element-138" data-mp="2add4prrxwxx4">
          <p className="absolute -top-3.5 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-orange px-5 py-2 text-[10px] font-extrabold uppercase tracking-[0.16em] text-white sm:text-[11px]" data-id="element-139" data-mp="pml7vloyzhcs">
            Musica Pronta
          </p>

          <dl className="text-[15px] sm:text-base" data-id="element-140" data-mp="13k9vh1af92lj">
            {lines.map(line => <div key={line.label} className="flex items-baseline justify-between gap-4 border-b border-navy/10 py-3.5 sm:py-4" data-id="element-141" data-mp="6u95x028ai36">
                <dt className="text-ink-soft" data-id="element-142" data-mp="fufjsn1u9k2v">{line.label}</dt>
                <dd className="font-semibold text-ink-soft line-through" data-id="element-143" data-mp="ft4eujwnq6a6">{line.value}</dd>
              </div>)}
            <div className="flex items-baseline justify-between gap-4 pt-4" data-id="element-144" data-mp="kmyxrl4fuh87">
              <dt className="text-sm font-extrabold uppercase tracking-[0.08em] text-navy sm:text-base" data-id="element-145" data-mp="3k8dov4kiz1sf">
                Totale valore:
              </dt>
              <dd className="text-base font-bold text-ink-soft line-through sm:text-lg" data-id="element-146" data-mp="vez0anxon90c">225 €</dd>
            </div>
          </dl>

          <div className="mt-8 rounded-3xl bg-orange-tint px-6 py-7 text-center" data-id="element-147" data-mp="qg4k7tr3nyjx">
            <p className="text-[10px] font-extrabold uppercase tracking-[0.24em] text-orange-deep sm:text-xs" data-id="element-148" data-mp="154il3z4yhcxu">
              Prezzo di oggi
            </p>
            <p className="mt-2 font-display text-[58px] font-extrabold leading-none tracking-tight text-navy sm:text-[76px]" data-id="element-149" data-mp="cgv4ev6t36gh">
              19{' '}
              <span className="text-[30px] font-bold tracking-normal sm:text-[40px]" data-id="element-150" data-mp="7j3c40291ibr">EUR</span>
            </p>
          </div>

          <div className="mt-8" data-id="element-151" data-mp="livwzer3h4bt">
            <CTAButton href={CHECKOUT_URL} className="w-full rounded-2xl py-5 sm:w-full sm:rounded-2xl sm:py-6 sm:text-lg" data-id="element-152" data-mp="hg7nr5ygxveb" />

            <p className="mt-5 text-center text-[11px] text-ink-soft sm:text-sm" data-id="element-153" data-mp="1wyt0c7zojqsk">
              Pagamento unico. Nessun abbonamento. Accesso immediato.
            </p>
          </div>
        </div>
      </div>
    </section>;
}